import React, { FC, useState } from 'react'
import AvatarConnector, { ConnectorProps as AvatarProps } from 'connectors/Avatar'
import { LoadingSpinner } from 'styles/loader'
import { uploadAvatarImage } from 'apis/private/uploadAvatar'
import UploadIcon from 'svg/upload-v2.svg'
import EditIcon from 'svg/edit-v3.svg'
import { updateImagePathBasedOnHostName } from '../../helpers'
import styles from './Header.module.scss'
import useQA from 'hooks/useQA'
type Props = AvatarProps & {
  userID: number
  avatar: string
}

const uploadAvatarImageApi = async ({
  imageFile,
  callbackFunc,
  addMessage,
}: Record<string, any>) => {
  const heroImageApi = await uploadAvatarImage(imageFile)

  if (heroImageApi.success) {
    const { medImage } = heroImageApi.payload
    callbackFunc({
      avatarImg: medImage,
    })
  } else {
    const { errorMessage } = heroImageApi.payload
    let flashErrorMessage = 'Profile image could not be uploaded'

    if (errorMessage) {
      flashErrorMessage = errorMessage
    }

    addMessage(flashErrorMessage, 'error')
    callbackFunc({
      isLoading: false,
    })
  }
}

const Avatar: FC<Props> = (props) => {
  const { userID, sessionUserID, avatar, addMessage } = props
  const [state, handleState] = useState({
    isLoading: false,
    avatarImg: avatar,
  })
  const { isLoading, avatarImg } = state
  const myOwnAccount = sessionUserID === Number(userID)
  const { testId } = useQA()
  const onFileChanged = async (ev: React.SyntheticEvent<HTMLInputElement>) => {
    ev.preventDefault()

    if ((ev.target as HTMLInputElement).files && (ev.target as HTMLInputElement).files?.length) {
      const { files } = ev.target as HTMLInputElement
      const imageFile = files?.[0]
      handleState((prevState) => ({ ...prevState, isLoading: true }))
      uploadAvatarImageApi({
        imageFile,
        callbackFunc: (data: Record<string, any>) => {
          handleState((prevState) => ({ ...prevState, isLoading: false, ...data }))
        },
        addMessage,
      })
    }
  }

  if (!avatar && !myOwnAccount) {
    return null
  }

  return (
    <div className={styles.avatar} {...testId('avatar')}>
      {isLoading && (
        <>
          <div className={styles.overlay} />
          <LoadingSpinner className={styles.loader} />
        </>
      )}
      {avatar && (
        <>
          <img
            src={updateImagePathBasedOnHostName(avatarImg)}
            className={styles.userAvatar}
            alt='profile avatar'
            role='presentation'
            itemProp='image'
          />

          {myOwnAccount && (
            <div className={styles.editAvatarSection}>
              <div className={styles.editAvatar} title='edit avatar'>
                <EditIcon />
              </div>
              <input
                className={styles.editInput}
                type='file'
                accept='image/png, image/jpeg, image/jpg'
                onChange={onFileChanged}
                aria-label='hidden'
              />
              <p>Edit Photo</p>
            </div>
          )}
        </>
      )}
      {myOwnAccount && !avatar && (
        <div className={styles.uploadAvatarSection}>
          <div className={styles.uploadAvatar}>
            <UploadIcon />
          </div>
          <input
            className={styles.uploadInput}
            type='file'
            accept='image/png, image/jpeg, image/jpg'
            onChange={onFileChanged}
            aria-label='hidden'
          />
          <p>Add Photo</p>
        </div>
      )}
    </div>
  )
}

export default AvatarConnector(Avatar)
